// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2VRUu","content":"LayoutSettings_content__HsLbB"};